import { AnimatePresence, motion } from 'motion/react';
import { ErrorState, ErrorStateIcons } from '@/shared/components/feedback/ErrorState';
import { useNetworkStatus } from '@/shared/hooks/useNetworkStatus';

/**
 * Full-screen overlay displayed when the browser goes offline.
 * Blocks all interaction with the app underneath and provides
 * a "Try again" button that re-evaluates connectivity.
 */
export function OfflineOverlay() {
  const { isOnline, recheckStatus } = useNetworkStatus();

  return (
    <AnimatePresence>
      {!isOnline && (
        <motion.div
          key="offline-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-background/95 backdrop-blur-sm"
        >
          <ErrorState
            icon={ErrorStateIcons.Network}
            size="lg"
            title="You're offline"
            description="Check your internet connection and try again."
            onRetry={recheckStatus}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
